import { defineMessages, type IntlShape } from 'react-intl';

import type { ChatUploadErrorCode } from './useChatFileUpload';

const chatUploadErrorMessages = defineMessages({
  file_too_large: {
    defaultMessage: 'File is too large',
    id: 'KiWGWuj1qP',
    description: 'Inline attachment error when an uploaded file is too large',
  },
  unsupported_type: {
    defaultMessage: 'Unsupported file type',
    id: 't4qVc/U/PC',
    description: 'Inline attachment error when an uploaded file type is unsupported',
  },
  rate_limited: {
    defaultMessage: 'Too many uploads. Wait a minute and try again.',
    id: 'm9qT1Yjfnz',
    description: 'Inline attachment error when uploads are rate limited',
  },
  upload_failed: {
    defaultMessage: 'Upload failed',
    id: 'G0c+xQ0qBW',
    description: 'Inline attachment error when an upload fails',
  },
});

export const formatChatUploadErrorMessage = (
  intl: IntlShape,
  errorCode: ChatUploadErrorCode
): string => intl.formatMessage(chatUploadErrorMessages[errorCode]);
